import environment from '@/helpers/Environment'
import moment from 'moment-timezone'
import { TimedItem } from '@/store/CartItem'
import { ComponentOptions } from '@/types/ComponentOptions'
import type { Moment } from 'moment-timezone/moment-timezone'

export function dateQueryParamToAPIRange(value: string) {
  const handlers = {
    today() {
      start.subtract(1, 'day')
    },

    tomorrow() {
      end.add(1, 'day')
    },

    // TODO Add Support for date values like thisWeekend, nextWeek
  }

  // TODO Support concrete date values. E.g. 2020-06-06
  if (!handlers[value]) {
    throw new Error('Unsupported date query string parameter: ' + value)
  }

  const start = moment.tz(environment.portal.timezone).endOf('day')
  const end = start.clone()
  handlers[value]()
  return [start.toISOString(), end.toISOString()]
}

export function formatCartItemDateTime(item: TimedItem, options?: ComponentOptions['cartWidget']): string | null {
  const dateTimeFormat: string = options?.dateTimeFormat ?? 'ddd, MMM D, YYYY [at] h:mm A'
  const dateOnlyFormat: string = options?.dateOnlyFormat ?? 'ddd, MMM D, YYYY'
  const timeOnlyFormat: string = options?.timeOnlyFormat ?? 'h:mm A'
  const dateTime = (moment: Moment) => moment.format(dateTimeFormat)
  const date = (moment: Moment) => moment.format(dateOnlyFormat)
  const time = (moment: Moment) => moment.format(timeOnlyFormat)
  const mode = item.event.meta.ticket_date_time
  const { startMoment: start, endMoment: end } = item

  if (item.allDay || mode === 'date-only') {
    return date(start)
  } else if (mode === 'hidden') {
    return null
  } else if (mode === 'show-end') {
    if (start.isSame(end, 'day')) {
      return `${date(start)} at ${time(start)} to ${time(end)}`
    } else {
      return `${dateTime(start)} to ${dateTime(end)}`
    }
  } else if (mode === 'dates-only-show-end') {
    if (start.isSame(end, 'day')) {
      return date(start)
    } else {
      return `${date(start)} to ${date(end)}`
    }
  } else if (mode == null || mode === '') {
    return dateTime(start)
  }

  return mode
}
